import { Box, Button, Modal, TextField } from "@mui/material";
import { useState } from "react";
import { passwordRecovery } from "../../../services/password-service";
import { modalStyle } from "../../../utils/modal-style";

export default function PasswordLostModal({ open, setOpen }) {
  const [email, setEmail] = useState("");
  const handleClose = () => setOpen(false);

  async function handleSubmit(e) {
    e.preventDefault();

    const result = await passwordRecovery(email);

    if (result.name === "AxiosError") {
      return alert(
        "Não foi possível completar sua solicitação. Favor tente novamente mais tarde"
      );
    }

    alert("Email enviado com sucesso. Siga as intruções recebidas por email.");
    setOpen(false);
  }

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="box-container" sx={modalStyle}>
          <form onSubmit={handleSubmit} className="form-container">
            <p>
              Para recuperar a senha, digite seu email para receber o código e o
              link para acesso.
            </p>
            <TextField
              label="Email"
              name="email"
              onChange={(e) => setEmail(e.target.value)}
              inputProps={{
                autoComplete: "off",
              }}
            />
            <Button type="submit" variant="contained">
              Enviar
            </Button>
          </form>
        </Box>
      </Modal>
    </>
  );
}
